/* eslint-disable no-unused-vars */
import { gsap } from 'gsap';

export default function fullHero(element) {

  const parent = element;

  if (!document.querySelector('.full-video')) {
    return
  }

  gsap.set(parent, { cursor: 'none' })

  const container = document.querySelector('.full-video');
  const inner = container.querySelector('.inner')
  // const video = element.querySelector('video');
  const closeButton = container.querySelector('button');

  const iframe = container.querySelector('iframe');
  const player = new Vimeo.Player(iframe);

  const containerTl = gsap.timeline({ paused: true });


  containerTl
    .to(container, { alpha: 1, duration: 0.5, ease: "power2.out", visibility: 'visible' }, ">")
    .to(
      inner,
      {
        scale: 1, alpha: 1, duration: 0.5, ease: "power2.out", onComplete: () => {
          player.play()

          const width = window.innerWidth;
          if (width < 640) {
            player.requestFullscreen();
          }
        }
      },
      ">"
    );

  parent.addEventListener('mouseover', (e) => {
    if (isTouchDevice()) {
      return
    }
    const cursor = document.createElement('div');

    const rect = e.target.getBoundingClientRect();

    let x = e.pageX - rect.left;
    let y = e.clientY - rect.top;

    // console.log(parent.querySelector('.custom-pointer:not(.deleting)'))

    if (parent.querySelector('.custom-pointer:not(.deleting)') == null) {
      cursor.classList.add('custom-pointer', 'pointer-cursor');
      cursor.innerHTML = '<div>Play</div>';

      parent.appendChild(cursor);
    }

    gsap.set(cursor, {
      left: x,
      top: y,
    });
    gsap.to(cursor, { alpha: 1, scale: 1, visibility: 'visible' });

    // cursor.innerHTML = 'DRAG';
  });

  parent.addEventListener('mouseleave', () => {
    if (isTouchDevice()) {
      return;
    }
    const cursor = document.querySelector('.custom-pointer');
    cursor.classList.add('deleting');
    gsap.to(cursor, {
      scale: 0.5,
      duration: 0.1,
      onComplete: () => {
        if (document.querySelector('.custom-pointer.deleting')) {
          parent.removeChild(cursor);
        }
      },
    });
  });


  parent.addEventListener('mousemove', (e) => {
    if (isTouchDevice()) {
      return;
    }
    e.stopPropagation();

    let cursor;
    let rect;
    let x;
    let y;

    if(!parent.querySelector('.custom-pointer')){
      cursor = document.createElement('div');
      rect = e.target.getBoundingClientRect();

      x = e.pageX - rect.left;
      y = e.clientY - rect.top;

      // console.log(parent.querySelector('.custom-pointer:not(.deleting)'))

      if (parent.querySelector('.custom-pointer:not(.deleting)') == null) {
        cursor.classList.add('custom-pointer', 'pointer-cursor');
        cursor.innerHTML = '<div>Play</div>';

        parent.appendChild(cursor);
      }

      gsap.to(cursor, { alpha: 1, scale: 1, visibility: 'visible' });

    }else{
      cursor = parent.querySelector('.custom-pointer');
      rect = e.target.getBoundingClientRect();
      x = e.pageX - rect.left;
      y = e.clientY - rect.top;
    }

    gsap.to(cursor, {
      left: x,
      top: y,
    });

    // console.log(x, y)
  });

  //create mouse if touch
  
  if (isTouchDevice()) {
    const cursor = document.createElement('div');

    // console.log(parent.querySelector('.custom-pointer:not(.deleting)'))

    cursor.classList.add('custom-pointer', 'pointer-cursor', 'is-touch');
    cursor.innerHTML = '<div>Play</div>';

    parent.appendChild(cursor);

  }

  
  container.addEventListener('mousemove', (e) => {
    e.stopPropagation();
  });
  
  container.addEventListener('mouseover', (e) => {
    e.stopPropagation();
  });

  container.addEventListener('click', (e)=>{
    e.stopPropagation();
    closeVideo();
  })

  
  parent.addEventListener('mousedown', (e) => {
    if (e.button == 0) {
      const cursor = parent.querySelector('.custom-pointer');

      gsap.to(cursor, {
        scale: 0.9,
      });

      containerTl.play();

      container.classList.add('show')
    }
  });

  parent.addEventListener('mouseup', () => {
    const cursor = parent.querySelector('.custom-pointer');
    gsap.to(cursor, {
      scale: 1,
    });
  });

  window.addEventListener('keyup', (e) => {
    if (container.classList.contains('show') && e.keyCode == 27) {
      closeVideo()
    }
  })

  closeButton.addEventListener('click', closeVideo)

  function closeVideo() {
    player.pause()
    container.classList.remove('show')
    containerTl.reverse();
  }

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  }

}

